import React, {PureComponent} from 'react';
import TranslatedText from '../../atoms/TranslatedText';
import ScrollIcon from '../../atoms/ScrollIcon';
import Video from '../../atoms/Video';

const LABELS = {
    problem: 'prizm.enhanced_visibility.problem_label',
    solution: 'prizm.enhanced_visibility.solution_label',
    action: 'prizm.enhanced_visibility.action_label',
};

export default class EnhanceVisibilitySection extends PureComponent {
    scrollableElement = React.createRef();

    componentDidUpdate() {
        this.scrollableElement.current.scrollTop = 2000;
    }

    componentDidMount() {
        this.scrollableElement.current.scrollTop = 2000;
    }

    render() {
        const {currentSection} = this.props;

        return (
            <div className="EnhanceVisibilitySection">
                <div className="EnhanceVisibilitySection-content">
                    <div
                        ref={this.scrollableElement}
                        className="EnhanceVisibilitySection-container scrollable">
                        <div className="scroller">
                            <div className="scroller-top">
                                <h3 className="top-title">
                                    <TranslatedText tag={LABELS.solution} />
                                </h3>
                                <div className="EnhanceVisibilitySection-description">
                                    <TranslatedText
                                        tag={currentSection.solution}
                                    />
                                </div>
                            </div>
                            <div className="EnhanceVisibilitySection-scroller-bottom">
                                <h3 className="top-title">
                                    <TranslatedText tag={LABELS.problem} />
                                </h3>
                                <div className="EnhanceVisibilitySection-description">
                                    <TranslatedText
                                        tag={currentSection.problem}
                                    />
                                </div>
                                <div className="EnhanceVisibilitySection-scrollIcon">
                                    <ScrollIcon tag={LABELS.action} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Video
                    className="EnhancedVisibility-video"
                    src={currentSection.video}
                    poster="data:image/gif,AAAA"
                    style={{backgroundImage: `url(${currentSection.poster})`}}
                    autoPlay
                    playsInline
                    muted
                    loop
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/prizm/EnhanceVisibilitySection.js